var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6665 5.49999C3.6665 4.99374 4.07691 4.58333 4.58317 4.58333H5.49984C6.00609 4.58333 6.4165 4.99374 6.4165 5.49999V16.5C6.4165 17.0063 6.00609 17.4167 5.49984 17.4167H4.58317C4.07691 17.4167 3.6665 17.0063 3.6665 16.5V5.49999Z",
    fill: "#B1B6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 10.5417C18.3333 10.0354 17.9229 9.625 17.4167 9.625H11.9167C11.4104 9.625 11 10.0354 11 10.5417V11.4583C11 11.9646 11.4104 12.375 11.9167 12.375H17.4167C17.9229 12.375 18.3333 11.9646 18.3333 11.4583V10.5417Z",
    fill: "#B1B6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9676 6.28242C13.2564 5.99369 13.7501 6.19818 13.7501 6.60652V15.3935C13.7501 15.8018 13.2564 16.0063 12.9676 15.7175L8.57418 11.3241C8.39519 11.1451 8.39519 10.8549 8.57418 10.6759L12.9676 6.28242Z",
    fill: "#B1B6C6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame (2).530acbbc58d1be9898c66cbba3e10de0.svg";
export { ForwardRef as ReactComponent };